<template>
  <div class="input-group text-area vertical-middle">
    <div :class="{'disable': isDisable, 'error': hasValidationError()}" style="width: 100%;height: 100%;">
      <textarea v-model="inputModel" :name="name" :rows="rows"
                :placeholder="placeholder" :disabled="isDisable"
                :class="className"
                class="scrollbar"></textarea>
    </div>

    <div v-if="hasValidationError()" class="validation-error">
      <LucideIcon icon="Info"/>
      <span
          v-for="(error, index) of validator.$errors"
          :key="index"
      >
      {{ error.$message }}
    </span>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {AbstractInputComponent} from '@shared/components/abstracts';

export default defineComponent({
  name: 'TextareaElement',
  extends: AbstractInputComponent,
  props: {
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    validator: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    inputModel: {
      get(): string {
        return this.value;
      },
      set(value: string): void {
        this.$emit('update:value', value);
      }
    }
  },
  methods: {
    hasValidationError(): boolean {
      return this.validator && this.validator.$errors.length;
    }
  }
});
</script>

<style lang="scss" scoped>
.input-group {
  border-radius: $br-sm;
  background-color: var(--form-bg);
  border: 1px solid var(--form-border);

  &:hover{
    background-color: var(--form-bg-hover);
    border: 1px solid var(--form-border-hover);
    box-shadow: var(--form-shadow-outline) !important;
  }

  &:focus,
  &:active,
  &:has(textarea:focus) {
    background-color: var(--form-bg-focus);
    border: 1px solid var(--form-border-focus);
    box-shadow: var(--form-shadow-outline) !important;
  }

  &.error {
    background-color: var(--form-bg);
    border: 1px solid var(--form-border);
    box-shadow: var(--form-shadow-outline) !important;
  }

  textarea {
    border: none;
    background: var(--transparent);
    color: var(--text-dark);
    width: 100%;
    resize: none;
    padding: var(--space-12) var(--space-12);
    font-size: var(--fs-14);
    outline: 0 !important;
    min-height: 120px;
    &.full--height{
      height: 100%;
    }
  }

}
</style>
